var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28967 20.347C15.837 20.347 19.9644 13.6738 19.9644 7.88699C19.9644 7.69748 19.9608 7.50883 19.9528 7.32096C20.7559 6.70077 21.449 5.93288 21.9996 5.05328C21.2644 5.40212 20.4732 5.63692 19.6432 5.74278C20.4904 5.20064 21.1408 4.34296 21.4476 3.32062C20.6421 3.83057 19.761 4.19006 18.8421 4.3836C18.0933 3.53238 17.0273 3 15.8469 3C13.581 3 11.7434 4.96116 11.7434 7.3786C11.7434 7.72228 11.7795 8.05647 11.8499 8.37713C8.43959 8.19399 5.41558 6.4514 3.39176 3.80169C3.02725 4.47 2.83553 5.22955 2.83616 6.00276C2.83616 7.5221 3.56054 8.86333 4.66214 9.64802C4.01053 9.62678 3.37322 9.43894 2.80381 9.10029C2.8032 9.11867 2.8032 9.13658 2.8032 9.15623C2.8032 11.277 4.21756 13.0478 6.09508 13.449C5.74246 13.5515 5.37859 13.6033 5.01311 13.6031C4.74917 13.6031 4.49194 13.5754 4.24195 13.5242C4.76434 15.2641 6.2791 16.5303 8.07504 16.5657C6.67064 17.7405 4.90153 18.4403 2.97876 18.4403C2.65167 18.4405 2.32485 18.4203 2 18.3796C3.81598 19.6218 5.97208 20.347 8.28967 20.347Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.50a995fe4225e7920266cd31cb9b169d.svg";
export { ForwardRef as ReactComponent };